import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { ReactNode } from 'react'

interface ContentSectionProps {
  title: string
  subtitle?: string
  icon: IconProp
  children: ReactNode
  className?: string
  headerRight?: ReactNode
}

const ContentSection: React.FC<ContentSectionProps> = ({
  title,
  subtitle,
  icon,
  className,
  children,
  headerRight
}) => (
  <div className={['rounded-lg border border-border-subtle bg-surface-card p-6', className].filter(Boolean).join(' ')}>
    <div className='flex flex-row items-center pb-8 justify-between'>
      <div className='flex flex-row items-center'>
        <div className='mr-4 flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
          <FontAwesomeIcon
            icon={icon}
            size='lg'
            className='text-icon-brand'
          />
        </div>

        <div>
          <p className='subtitle'>{title}</p>

          {subtitle && <p className='light'>{subtitle}</p>}
        </div>
      </div>

      {headerRight}
    </div>

    {children}
  </div>
)

export default ContentSection
